var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-table gutter-lg mb"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("body"),_vm._v(" "),_c('table',_vm._l((_vm.data),function(d,index){return _c('tr',[_c('td',[_vm._v(_vm._s(d.left))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(d.right))])])})),_vm._v(" "),_c('p',{staticClass:"disclaimer"},[_vm._v(_vm._s(_vm.disclaimer))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00859230","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table.vue
// module id = null
// module chunks = 